module.exports = __webpack_public_path__ + "img/团队优胜单位@2x.25e008f0.png";